import { supabase } from "@/integrations/supabase/client";

export type EventKind = "view" | "phone" | "whatsapp" | "message" | "favorite" | "share";

export type ListingEvent = {
  id: string;
  listing_id: string;
  owner_id: string | null;
  kind: EventKind;
  created_at: string;
};

/** Elan üzərindəki hərəkəti qeyd edir (səssiz — xəta UI-ni pozmur). */
export async function logListingEvent(
  listingId: string,
  kind: EventKind,
  ownerId?: string | null,
) {
  if (!listingId) return;
  try {
    await supabase
      .from("listing_events")
      .insert({ listing_id: listingId, kind, owner_id: ownerId ?? null });
  } catch {
    /* statistika kritik deyil */
  }
}

export async function fetchOwnerEvents(ownerId: string, days = 30): Promise<ListingEvent[]> {
  const since = new Date(Date.now() - days * 86400000).toISOString();
  const { data, error } = await supabase
    .from("listing_events")
    .select("*")
    .eq("owner_id", ownerId)
    .gte("created_at", since)
    .order("created_at", { ascending: false })
    .limit(5000);
  if (error) throw error;
  return (data ?? []) as unknown as ListingEvent[];
}

export type DayPoint = { day: string; views: number; contacts: number };

/** Günlərə görə baxış və əlaqə saylarını hesablayır. */
export function groupByDay(events: ListingEvent[], days: number): DayPoint[] {
  const out: DayPoint[] = [];
  const map = new Map<string, DayPoint>();
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(Date.now() - i * 86400000);
    const key = d.toISOString().slice(0, 10);
    const point: DayPoint = { day: key, views: 0, contacts: 0 };
    map.set(key, point);
    out.push(point);
  }
  for (const e of events) {
    const key = e.created_at.slice(0, 10);
    const point = map.get(key);
    if (!point) continue;
    if (e.kind === "view") point.views += 1;
    else if (e.kind === "phone" || e.kind === "whatsapp" || e.kind === "message")
      point.contacts += 1;
  }
  return out;
}

export function countBy(events: ListingEvent[], kind: EventKind) {
  return events.filter((e) => e.kind === kind).length;
}

export function perListing(events: ListingEvent[]) {
  const map = new Map<string, { views: number; contacts: number; shares: number }>();
  for (const e of events) {
    const row = map.get(e.listing_id) ?? { views: 0, contacts: 0, shares: 0 };
    if (e.kind === "view") row.views += 1;
    else if (e.kind === "share") row.shares += 1;
    else if (e.kind === "phone" || e.kind === "whatsapp" || e.kind === "message")
      row.contacts += 1;
    map.set(e.listing_id, row);
  }
  return map;
}
